<script setup>
const emit = defineEmits(['doReturn']);
</script>

<template>
  <div class="modal com_modal2 fade" id="returnConfirmModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_attention1.png" alt="" class="icon_c_check1">
          <h3 class="com_fs18 com_strong1 com_center1 com_mgb0">ご確認ください</h3>
          <p class="com_fs14 com_center1 com_mgb0">返品希望商品に、開封品・箱のつぶれなどはありませんでしょうか？</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn1" @click.prevent="emit('doReturn')">はい</button>
          <button type="button" class="btn com_btn2" data-bs-dismiss="modal">いいえ</button>
        </div>
      </div>
    </div>
  </div>
</template>
